import AxiosInstance from './config/Http'
import Config, { HOST } from './config/Constants'

export default {
    attach: (unitId: string, idDocumentType: string, dueDate: string, classification: string, file: File) => {
      const formData = new FormData();
      formData.append("file", file);
      let queryParams = `?idDocumentType=${idDocumentType}&dueDate=${dueDate}`;
      if (classification) {
        queryParams += `&classification=${classification}`;
      }
      return AxiosInstance.post<any[]>(`${Config.core.documents}/attach/${unitId}${queryParams}`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" }
        }
      )
    },
    getFile: (fileUrl: string) => AxiosInstance.get<any[]>(`${HOST}/${fileUrl}`, { responseType: 'arraybuffer' })
}